import React from "react";
import { Link } from "react-router-dom";
import { fmtOrderRupee } from "../../pages/storeSalesDashboardHelpers";

export default function CreditNoteUsageProjects({
  usageProjects,
  showOrderValue = true,
  compact = false,
}) {
  const rows = Array.isArray(usageProjects) ? usageProjects : [];

  if (rows.length === 0) {
    return <span className="text-muted">—</span>;
  }

  return (
    <ul className={`list-unstyled mb-0 ${compact ? "small" : ""}`}>
      {rows.map((row) => {
        const key = `${row.project_id}-${row.credit_applied}-${row.adjusted_at}`;
        const label = row.project_name || `Order #${row.project_id}`;
        return (
          <li key={key} className={rows.length > 1 ? "mb-1" : ""}>
            {row.project_id ? (
              <Link
                to={`/projects/${row.project_id}`}
                className="text-decoration-none fw-semibold"
              >
                {label}
              </Link>
            ) : (
              <span className="fw-semibold">{label}</span>
            )}
            {showOrderValue && row.project_value != null ? (
              <div className="text-muted small">
                Order value: {fmtOrderRupee(row.project_value)}
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
